<ng-container *ngIf="action$ | async as action">
  @let isDisabled = isDisabled$ | async;
  <p-button
    [icon]="'pi ' + (action.icon ? 'pi-' + action.icon : 'pi-hidden')"
    [ngClass]="action.name + ' hide-label-responsive'"
    [label]="getDescription()"
    ntapDebounceClick
    (onClick)="executeAction($event)"
    [disabled]="isDisabled ?? true"
    [pTooltip]="getDescription()"
    tooltipPosition="left"
  ></p-button>
</ng-container>
